import { relations } from 'drizzle-orm'
import { date, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getNullableIdReference,
} from '../common/utils'
import { attachments } from './attachment'
import { employeeSkills } from './employeeSkill'
import { users } from './user'

export const genderEnum = pgEnum('gender', [
  'male',
  'female',
  'other',
  'prefer_not_to_say',
])

export const employees = pgTable(
  'employees',
  {
    ...getBaseFields(),
    userId: getIdReference(() => users.id),
    role: text().notNull(), // Employee role within the organization
    phoneNumber: text(),
    birthDate: date(),
    gender: genderEnum(),
    avatarAttachmentId: getNullableIdReference(() => attachments.id),
  },
  (table) => getBaseIndexes('employees', table),
)

// Employee relations
export const employeesRelations = relations(employees, ({ one, many }) => ({
  user: one(users, {
    fields: [employees.userId],
    references: [users.id],
  }),
  avatar: one(attachments, {
    fields: [employees.avatarAttachmentId],
    references: [attachments.id],
  }),
  employeeSkills: many(employeeSkills),
}))
